import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, FlaskConical, Truck, Lock, Mail } from "lucide-react";
import Logo from "./Logo";
import { CATEGORIES } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      {/* trust strip */}
      <div className="border-b border-slate-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: FlaskConical, t: "99%+ HPLC Purity", s: "Batch verified" },
            { icon: Truck, t: "Same-Day Dispatch", s: "AusPost Express" },
            { icon: ShieldCheck, t: "CoA Every Batch", s: "Full traceability" },
            { icon: Lock, t: "Secure Checkout", s: "256-bit SSL" },
          ].map((f) => (
            <div key={f.t} className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-blue-600/15 text-blue-400 flex items-center justify-center shrink-0">
                <f.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="text-sm font-semibold text-white">{f.t}</div>
                <div className="text-xs text-slate-400">{f.s}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo variant="light" size="md" />
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Australia's research-first peptide supplier. Independent batch testing,
            published CoAs and express nationwide dispatch.
          </p>
          <p className="mt-4 text-xs text-slate-500">FesX Peptides Australia</p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4">Shop</h4>
          <ul className="space-y-2.5 text-sm">
            {CATEGORIES.slice(1, 7).map((c) => (
              <li key={c.slug}>
                <Link to={`/shop?cat=${c.slug}`} className="text-slate-400 hover:text-blue-400 transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="text-slate-400 hover:text-blue-400 transition-colors">About Us</Link></li>
            <li><Link to="/faq" className="text-slate-400 hover:text-blue-400 transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors">Contact</Link></li>
            <li><Link to="/shop" className="text-slate-400 hover:text-blue-400 transition-colors">All Products</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4">Stay Updated</h4>
          <p className="text-sm text-slate-400 mb-3">New batches & CoA releases.</p>
          <form onSubmit={(e) => e.preventDefault()} className="flex items-center gap-2">
            <div className="relative flex-1">
              <Mail className="absolute left-3 top-2.5 h-4 w-4 text-slate-500" />
              <input
                type="email"
                placeholder="Email address"
                className="w-full rounded-lg bg-slate-800 border border-slate-700 pl-9 pr-3 py-2 text-sm text-white placeholder-slate-500 outline-none focus:border-blue-500"
              />
            </div>
            <button className="rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold px-4 py-2 transition-colors">
              Join
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} FesX Peptides Australia. All rights reserved.
          </p>
          <p className="text-xs text-slate-500 max-w-xl md:text-right">
            <span className="text-slate-400 font-semibold">Research Use Only:</span> All products are strictly for
            in-vitro laboratory research. Not for human or veterinary consumption. You must be 18+.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
